import { useEffect, useState } from "react";
import TextField from "../../../../common/components/inputFields/textFields/textField";
import { StoryModel } from "../../models/questionModel";
import { ReactComponent as Exit } from "../../../../assets/exitIcon.svg";
import "./storyArea.scss";
import UploadImageArea from "../../../../common/components/uploadImageArea/uploadImageArea";
import { ReactComponent as Arrow } from "../../../../assets/arrowIcon.svg";
import { Color } from "../../../../common/style/colors";

export default function StoryArea(props: {
  storyData?: StoryModel;
  onChange?: (e: StoryModel) => void;
  onClickClose?: () => void;
  onClickUp?: () => void;
  onClickDown?: () => void;
}) {
  const [question, setQuestion] = useState<StoryModel>(
    props.storyData ?? ({} as StoryModel)
  );

  useEffect(() => {
    props.onChange?.(question);
  }, [question]);

  return (
    <div style={{ display: "flex", gap: "0.5rem" }}>
      <div style={{ display: "flex", flexDirection: "column", gap: "0.5rem" }}>
        <Arrow
          height={12}
          width={12}
          stroke={Color().blackColor}
          className={"arrowUp"}
          style={{ cursor: "pointer" }}
          onClick={props.onClickUp}
        />
        <Arrow
          height={12}
          width={12}
          stroke={Color().blackColor}
          className={"arrowDown"}
          style={{ cursor: "pointer" }}
          onClick={props.onClickDown}
        />
      </div>
      <div className="story-area">
        <div className="story-area-header">
          <TextField
            initialValue={question.storyTitle ?? "Untitled Story"}
            fontSize="16px"
            padding="2px"
            hideBorder
            onChange={(e) => {
              let newData = {
                ...question,
                storyTitle: e,
              } as StoryModel;
              setQuestion(newData);
            }}
            maxWidth={"150px"}
          />
          <Exit
            height={20}
            width={20}
            onClick={props.onClickClose}
            style={{ cursor: "pointer" }}
            stroke={"black"}
          />
        </div>
        <hr />
        <div className="story-area-detail-container">
          <div className="story-area-detail">
            <UploadImageArea
              image={question.storyImage}
              height="100px"
              onChange={(e) => {
                let newData = {
                  ...question,
                  storyImage: e,
                } as StoryModel;
                setQuestion(newData);
              }}
            />
            <TextField
              initialValue={question.storyDescription ?? ""}
              isFullWidth
              extendable
              placeHolder="Description"
              border="2px solid rgba(0, 0, 0, 0.1)"
              onChange={(e) => {
                let newData = {
                  ...question,
                  storyDescription: e,
                } as StoryModel;
                setQuestion(newData);
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
